<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    :paginate-elements-by-height="1100"
    :filename="fileName"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    ref="html2Pdf"
    :html-to-pdf-options="htmlToPdfOptions"
    @hasDownloaded="hasDownloaded()"
  >
    <template slot="pdf-content">
      <div class="pdf-template" v-for="item in dataList" :key="`qr-${item.id}`">
        <div class="header">
          <div class="logo_box_container">
            <img
              v-if="vg_activeBusinessLogo"
              :src="vg_activeBusinessLogo"
              width="80px"
              height="80px"
            />
            <img v-else src="../../assets/images/gr8table-black.png" width="80px" />
          </div>
          <div
            class="badge"
            :style="
              `background-color: ${vg_activeBusinessBrandingAndLogo.primary};`
            "
          >
            <p style="line-height: 0.75rem">TABLE #</p>
            <h2>{{ item.table_number }}</h2>
            <span class="badge_design"></span>
          </div>
        </div>
        <div class="body">
          <div
            class="background_design"
            :style="
              `background-color: ${vg_activeBusinessBrandingAndLogo.primary};`
            "
          ></div>
          <div class="qr_content">
            <div class="qr_box_container">
              <div class="qr_box">
                <qrcode-vue
                  :value="getQrUrl(item)"
                  :renderAs="renderAs"
                  :size="size"
                  :level="level"
                  :background="background"
                  :foreground="foreground"
                />
              </div>
            </div>
            <div class="list_box">
              <p :style="`color: ${vg_activeBusinessBrandingAndLogo.primary};`">Menu              </p>
              <p :style="`color: ${vg_activeBusinessBrandingAndLogo.primary};`">Order</p>
              <p :style="`color: ${vg_activeBusinessBrandingAndLogo.primary};`">Server</p>
              <p :style="`color: ${vg_activeBusinessBrandingAndLogo.primary};`">Pay</p>
            </div>
          </div>
        </div>
        <div
          class="footer"
          :style="
            `background-color: ${vg_activeBusinessBrandingAndLogo.primary};`
          "
        >
          <!-- <p>POWERED BY</p> -->
          <img :src="getImage()" width="60px" />
        </div>
      </div>
    </template>
  </vue-html2pdf>
</template>

<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import VueHtml2pdf from 'vue-html2pdf'
import { GR8TABLE_URL } from '@/clients/env.js'

export default {
  name: 'QrToHtml',
  components: {
    QrcodeVue,
    VueHtml2pdf
  },
  props: {
    fileName: {
      type: String,
      default: () => 'table-admin-pdf'
    },
    dataList: {
      type: Array,
      default: () => [1]
    }
  },
  data() {
    return {
      size: 300,
      level: 'L',
      background: '#ffffff',
      foreground: '#000000',
      renderAs: 'canvas',
      showLayout: false
    }
  },
  computed: {
    ...mapGetters({
      vg_selectedLocation: 'auth/selectedLocation',
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_activeBusinessLogo: 'auth/activeBusinessLogo',
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    }),
    htmlToPdfOptions() {
      return {
        filename: this.fileName,
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          dpi: 300,
          letterRendering: true
        }
      }
    }
  },
  methods: {
    hasDownloaded() {
      this.$emit('hasDownloaded')
    },
    generatePdf() {
      this.$refs.html2Pdf.generatePdf()
    },
    getQrUrl(tableObj) {
      // qr code url
      return `${GR8TABLE_URL}/${this.vg_selectedBusiness.slug}/${this.vg_selectedLocation.slug}/menu?allow_to_join=true&receive_method=dinein&table_id=${tableObj.table_number}`
    },
    getImage() {
      return require(`../../assets/images/gr8table-${this.$vuetify.theme.themes.light.primary === '#ffffff' ? 'black' : 'white'}.png`)
    }
  }
}
</script>

<style scoped>
.pdf-template {
  border: 3px solid rgb(0, 0, 0);
  text-align: center;
  background-color: white;
  height: 1122px;
  width: 800px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  font-family: sans-serif;
  overflow: hidden;
}
/* Header */
.header {
  display: flex;
  justify-content: end;
  padding-right: 30px;
  align-items: center;
  margin-bottom: 80px;
}
.logo_box_container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo_box_container > img {
  margin-left: 140px;
}
.badge {
  position: relative;
  width: 80px;
  height: 100px;
  overflow: hidden;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  padding: 10px 5px 20px;
  margin-left: 20px;
  border-color: transparent;
  /* background-color: #df2727; */
}

.badge > h2 {
  color: #ffffff;
  margin: 2px 0px;
  padding: 0px;
  font-weight: bold;
  font-size: 22px;
}
.badge > p {
  font-size: 13px;
  font-weight: normal;
  color: #e9e7e7;
  margin: 2px 0px;
  padding: 0px;
}

.badge_design {
  position: absolute;
  top: 100%;
  background-color: white;
  width: 188px;
  height: 188px;
  transform: rotate(-45deg);
}
/* Header */
/* Body */
.body {
  position: relative;
  flex: 1;
}
.background_design {
  position: absolute;
  width: 1300px;
  height: 1300px;
  border-radius: 50%;
  z-index: 0;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* background-color: #df2727; */
}
.qr_content {
  flex: 1;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: column;
  overflow: hidden;
}
.qr_box {
  width: fit-content;
  height: auto;
  margin: 120px auto 0px;
  padding: 30px;
  border-radius: 25px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 16px 20px;
  margin: 20px 0 0;
}
.list_box > p {
  /* color: #df2727; */
  font-weight: bold;
  font-size: 22px;
  flex: 1;
  font-weight: bold;
  margin: 10px 0;
  text-align: center;
}
/* Body */
/* Footer */
.footer {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 10px;
  /* background-color: #df2727; */
}
.footer > p {
  color: #ffffff;
}
.footer > img {
  margin-left: 10px;
}
</style>
